// @ts-nocheck
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import GridContainer from "@insite/mobius/GridContainer";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React from "react";
import { css } from "styled-components";

interface Props {
    children: React.ReactNode;
    extendedStyles?: AccordionLayoutStyles;
    overrideStyles?: AccordionLayoutStyles;
}
interface AccordionLayoutStyles {
    accordion?: AccordionPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
    gridContainer?: GridContainerProps;
}
const accordionLayoutStyles: AccordionLayoutStyles = {
    gridContainer: {
        offsetCss: css`
            padding: 0rem;
            padding-block: 0;
            align-items: flex-end;
        `,
    },
};

const AccordionLayout: React.FC<Props> = ({ children, extendedStyles, overrideStyles }) => {
    const pageTitle = useCurrentPage()?.fields?.title;
    const styles = useExpandProps(accordionLayoutStyles, extendedStyles, overrideStyles);
    const [toggleFilters, setToggleFilters] = React.useState(true);
    return (
        <Accordion headingLevel={2} {...styles.accordion}>
            <AccordionSection
                title={pageTitle}
                expanded={toggleFilters}
                onTogglePanel={() => setToggleFilters(toggleFilters => !toggleFilters)}
                {...styles.accordionSection}
            >
                <GridContainer {...styles.gridContainer}>{children}</GridContainer>
            </AccordionSection>
        </Accordion>
    );
};

export default React.memo(AccordionLayout);
